export class GameViewStorage {
    public static isViewLoad: boolean = false;
    public static gamePool: PIXI.Container;
    public static originY: number;
    public static bar: PIXI.Container;
    public static originBarY: number;
    public static productCounter: PIXI.Container;
    public static productCounterOriginY: number;
    public static isMapLoad: boolean;
    public static headerShift: number = 0;
    public static mechanicShift: number = 0;

    public static setIsMap(state: boolean): void {
        this.isMapLoad = state;
    }

    public static setIsView(state: boolean): void {
        this.isViewLoad = state;
    }
}